import { cn } from "~/lib/utils";

export function Section(
  props: React.ComponentProps<"section"> & { noHr?: boolean },
) {
  const { className, children, title, noHr = false, ...rest } = props;
  return (
    <section
      className={cn(className, "my-4 rounded-sm bg-white p-4 shadow")}
      title={title}
      {...rest}
    >
      {title && <h2 className="text-2xl font-bold">{title}</h2>}
      {children}
      {/* {!noHr && <hr />} */}
    </section>
  );
}
